import { useForm } from "react-hook-form";
import { IFormInput, QuestionsResponse, QuizInduction, ResponseBeneficiary } from "../TypesOrInterfaces/induction";
import { api } from "../services/api";
import { FAZ_BEM_ID } from "../util/aliasHidden";
import { useAstrazeneca } from "./useAstrazeneca";
import { useInduction } from "./useInduction";
import { useEffect, useState } from "react";




export const useQuiz = () => {
    const { 
        beneficiaryRegister
        , configuration
        , token
        , benefitId
        , cardHolderNumber
        , setBeneficiary
        ,addFields
        ,addQuiz } = useInduction()
    const { termBeneficiary } = useAstrazeneca(configuration, benefitId)
    const { getValues } = useForm()
    const [hasAwnserTerm,setHasAwnserTerm] = useState()
    
    
    const updateQuizzes = async (data: IFormInput, quizId: number) => {

        

        try {

            const questionsFilter = beneficiaryRegister.quiz?.filter(f => f.id === quizId)[0]?.questions.map(question => {

                if (!data.hasOwnProperty(String(question.id))) {
                    return {} as QuestionsResponse
                }
                return question;

            }).filter(f => f.id) || []; 

            const newValueQuestions = configuration.quiz?.filter(c => c.id === quizId)[0]?.questions.map(questionConfig => {

                if (data.hasOwnProperty(String(questionConfig.id))) {
                    return {
                        id: questionConfig.id,
                        value: data[questionConfig.id]
                    } as QuestionsResponse
                }

                return {} as QuestionsResponse
            }).filter(f => f.id && f.value != undefined);

            const responseQuizBeneficiary = (configuration.quiz?.filter(f => f.id === quizId)[0]) as any
            responseQuizBeneficiary.skuId = responseQuizBeneficiary.drugs.map((x: any) => x.skuId)

            
            const body = {
                quiz: [
                    {
                        id: responseQuizBeneficiary.id,
                        configurationId: responseQuizBeneficiary.configurationId,
                        skuId: responseQuizBeneficiary.skuId,
                        questions: questionsFilter.map(x => {
                            return {
                                id: x.id,
                                value: newValueQuestions.find(e => e.id === x.id)?.value ?? x.value
                            }
                        }
                        ) //[...questionsFilter, ...newValueQuestions]
                    } as QuizInduction
                ]
            }

            const response = await api.put<ResponseBeneficiary>(`Beneficiary/api/v1/Beneficiary/DynamicQuizzes/${benefitId}/${cardHolderNumber}`
                , body, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            });

            if (response.status !== 200) {
                console.error('Ocorreu um erro ao atualizar o aceite de termo');

                return;
            }
        }
        catch (ex) {
            // toast.error('Ocorreu um erro na aplicação por favor tente mais tarde!');
            console.log(ex)
            return;
        }
        finally {
            // resetAll();
        }
    } 

    return {
        updateQuizzes
    }
}

